module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br', {
    staticClass: "hidden-md hidden-lg"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goAccount()
      }
    }
  }, [_vm._v("My Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goBookings()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o"
  }), _vm._v(" My Bookings\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goCalendar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Calendar and Availability\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goProfileSetup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v(" Profile Setup\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goViewPublicProfile()
      }
    }
  }, [_vm._v("\n    View Public Profile\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block",
    on: {
      "click": function($event) {
        _vm.goContactSupport()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-support"
  }), _vm._v(" Contact Support\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69853088!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Shortcuts.vue
// module id = 639
// module chunks = 2